import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../core/modules/shared.module';

import { SimpleListComponent } from './simple-list.component';

@NgModule({
  declarations: [
    SimpleListComponent,
  ],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [SimpleListComponent]
})
export class SimpleListModule { }



// WEBPACK FOOTER //
// ./src/app/main/content/simple-list/simple-list.module.ts